module.exports = __webpack_public_path__ + "img/bottom.1db7a30b.png";